<script>
import axios from '@/utils/axios';

export default {
  inject: ['setLoading'],
  data() {
    return {
      showPassword: false,
      showPassword1: false,
      token: '',
      email: '',
      password: '',
      password_confirmation: '',
      errors: {},
      tokenValid: false,
      checking: true,
      marqueeRow1: [
        { id: 1, icon: '🔥', title: 'Track Every Order', subtitle: 'from quotation to dispatch' },
        { id: 2, icon: '📊', title: 'Smart Dashboard', subtitle: 'all metrics at a glance' },
        { id: 3, icon: '🏭', title: 'Inventory Control', subtitle: 'real-time stock tracking' },
        { id: 4, icon: '🔥', title: 'Track Every Order', subtitle: 'from quotation to dispatch' },
        { id: 5, icon: '📊', title: 'Smart Dashboard', subtitle: 'all metrics at a glance' },
        { id: 6, icon: '🏭', title: 'Inventory Control', subtitle: 'real-time stock tracking' },
      ],
      marqueeRow2: [
        { id: 1, icon: '📦', title: 'Delivery Challans', subtitle: 'streamlined dispatch flow' },
        { id: 2, icon: '🔔', title: 'Never Miss a Follow-up', subtitle: 'automated reminders' },
        { id: 3, icon: '🔒', title: '100% Secure & Private', subtitle: 'your data is safe' },
        { id: 4, icon: '📦', title: 'Delivery Challans', subtitle: 'streamlined dispatch flow' },
        { id: 5, icon: '🔔', title: 'Never Miss a Follow-up', subtitle: 'automated reminders' },
        { id: 6, icon: '🔒', title: '100% Secure & Private', subtitle: 'your data is safe' },
      ],
    };
  },
  mounted() {
    this.updateBodyClass();
    this.token = this.$route.query.token || '';
    this.email = this.$route.query.email || '';
    this.verifyToken();
  },
  watch: {
    $route() {
      this.updateBodyClass();
    },
  },
  methods: {
    updateBodyClass() {
      if (this.$route.path.includes("/reset-password")) {
        document.body.classList.add("bg-white");
      } else {
        document.body.classList.remove("bg-white");
      }
    },
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    toggleShow1() {
      this.showPassword1 = !this.showPassword1;
    },
    async verifyToken() {
      if (!this.token || !this.email) {
        this.tokenValid = false;
        this.checking = false;
        this.$swalToast('Invalid reset link', 'error');
        return;
      }
      this.setLoading(true);
      try {
        await axios.post('/auth/verify-token', {
          token: this.token,
          email: this.email,
        });
        this.tokenValid = true;
      } catch (error) {
        this.tokenValid = false;
        this.$swalToast(error.response?.data?.message || 'Invalid or expired reset link', 'error');
      } finally {
        this.checking = false;
        this.setLoading(false);
      }
    },
    async submitForm() {
      this.errors = {};
      if (!this.password) {
        this.errors.password = ['Please enter a password'];
        return;
      }
      if (this.password.length < 8) {
        this.errors.password = ['Password must be at least 8 characters'];
        return;
      }
      if (this.password !== this.password_confirmation) {
        this.errors.password_confirmation = ['Passwords do not match'];
        return;
      }
      this.setLoading(true);
      try {
        const response = await axios.post('/auth/reset-password', {
          email: this.email,
          token: this.token,
          password: this.password,
          password_confirmation: this.password_confirmation,
        });
        this.$swalToast(response.data.message || 'Password reset successfully!', 'success');
        this.$router.push('/');
      } catch (error) {
        if (error.response?.data?.errors) {
          this.errors = error.response.data.errors;
        } else {
          this.$swalToast(error.response?.data?.message || 'Failed to reset password', 'error');
        }
      } finally {
        this.setLoading(false);
      }
    },
  },
};
</script>

<template>
<div class="container-fuild">
<div class="w-100 overflow-hidden position-relative flex-wrap d-block vh-100">
<div class="row">
<div class="col-lg-6">
  <div
    class="login-background position-relative d-none d-lg-flex align-items-center justify-content-center flex-wrap vh-100"
    style="background: linear-gradient(135deg, #1a0a0a 0%, #2d1010 40%, #1c1c2e 100%); overflow: hidden;"
  >
    <div class="position-absolute top-0 start-0 w-100 h-100" style="background-image:linear-gradient(rgba(255,255,255,0.02) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,0.02) 1px,transparent 1px);background-size:40px 40px;pointer-events:none;"></div>

    <div class="position-absolute" style="top:-80px;left:-80px;width:300px;height:300px;background:radial-gradient(circle,rgba(232,64,64,0.25) 0%,transparent 70%);pointer-events:none;"></div>
    <div class="position-absolute" style="bottom:-60px;right:-60px;width:250px;height:250px;background:radial-gradient(circle,rgba(255,120,50,0.2) 0%,transparent 70%);pointer-events:none;"></div>

    <div class="authentication-card w-90 position-relative" style="z-index:2;">

      <div class="mb-4">
        <img src="@/assets/img/logo-ifes.png" alt="IFES Logo" style="height:60px;width:auto;object-fit:contain;" />
      </div>

      <h1 class="fw-bold lh-sm mb-2" style="color:#fff;font-size:35px;">
        One platform to manage <br/>
        <span style="color:rgba(255,255,255,0.7);">your Orders, Inventory</span><br/>
        <span style="color:rgb(27 42 130)">& close deals faster.</span>
      </h1>
      <p class="mb-4" style="color:#fff;font-size:16px;">
        The smarter way to manage leads, fire door orders <br> & dispatch operations.
      </p>

      <div class="marquee-wrapper mb-3" style="overflow:hidden;">
        <div class="marquee-track">
          <div v-for="card in marqueeRow1" :key="'a'+card.id" class="marquee-card">
            <span style="font-size:16px;">{{ card.icon }}</span>
            <div>
              <div class="fw-semibold text-white" style="font-size:14px;">{{ card.title }}</div>
              <div style="color:rgba(255,255,255,0.5);font-size:12px;">{{ card.subtitle }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="marquee-wrapper mb-4" style="overflow:hidden;">
        <div class="marquee-track marquee-reverse">
          <div v-for="card in marqueeRow2" :key="'b'+card.id" class="marquee-card" style="background:rgba(232,64,64,0.12);border-color:rgba(232,64,64,0.25);">
            <span style="font-size:16px;">{{ card.icon }}</span>
            <div>
              <div class="fw-semibold text-white" style="font-size:14px;">{{ card.title }}</div>
              <div style="color:rgba(255,255,255,0.5);font-size:12px;">{{ card.subtitle }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-between pt-3 border-top" style="border-color:rgba(255,255,255,0.08) !important;">
        <div>
          <div class="fw-bold text-white" style="font-size:25px;">24/7</div>
          <div style="color:rgba(255,255,255,0.4);font-size:16px;">Support Ready</div>
        </div>
        <div>
          <div class="fw-bold text-white" style="font-size:25px;">99.9%</div>
          <div style="color:rgba(255,255,255,0.4);font-size:16px;">Uptime Guaranteed</div>
        </div>
        <div>
          <div class="fw-bold text-white" style="font-size:25px;">100%</div>
          <div style="color:rgba(255,255,255,0.4);font-size:16px;">Secure & Private</div>
        </div>
      </div>

    </div>
  </div>
</div>
<div class="col-lg-6 col-md-12 col-sm-12">
<div class="row justify-content-center align-items-center vh-100 overflow-auto flex-wrap">
<div class="col-md-7 mx-auto p-4">
<form @submit.prevent="submitForm">
  <div>
    <div class="mx-auto mb-5 text-center">
      <img src="@/assets/img/logo.webp" class="img-fluid" alt="Logo" width="250" />
    </div>

    <!-- Checking token -->
    <div v-if="checking" class="text-center py-5">
      <i class="ti ti-loader" style="font-size:32px;color:#e84040;"></i>
      <p class="mt-3 text-muted">Verifying reset link...</p>
    </div>

    <!-- Invalid token -->
    <div v-else-if="!tokenValid" class="text-center py-5">
      <i class="ti ti-circle-x" style="font-size:48px;color:#f43f5e;"></i>
      <h2 class="aa-form-title mt-3 mb-2">Invalid or Expired Link</h2>
      <p class="aa-form-subtitle mb-4">This password reset link is invalid or has expired. Please request a new one.</p>
      <router-link to="/forgot-password" class="btn aa-btn-signin">Request New Link</router-link>
    </div>

    <!-- Valid token - reset form -->
    <div v-else>
      <div class="text-center mb-4">
        <h2 class="aa-form-title mb-2">Reset Password</h2>
        <p class="aa-form-subtitle mb-0">Your new password must be different from previous passwords.</p>
      </div>

      <!-- Password -->
      <div class="mb-3">
        <label class="form-label aa-label">New Password</label>
        <div class="aa-input-group">
          <span class="aa-input-icon-left">
            <i class="ti ti-lock"></i>
          </span>
          <input :type="showPassword ? 'text' : 'password'" v-model="password" class="form-control aa-input" placeholder="Enter new password" />
          <span @click="toggleShow" class="aa-input-toggle">
            <i class="ti" :class="{ 'ti-eye': showPassword, 'ti-eye-off': !showPassword }"></i>
          </span>
        </div>
        <div v-if="errors.password" class="text-danger small mt-1">{{ errors.password[0] }}</div>
        <p class="fs-12 text-muted mt-1">Use 8 or more characters with a mix of letters, numbers & symbols.</p>
      </div>

      <!-- Confirm Password -->
      <div class="mb-3">
        <label class="form-label aa-label">Confirm Password</label>
        <div class="aa-input-group">
          <span class="aa-input-icon-left">
            <i class="ti ti-lock"></i>
          </span>
          <input :type="showPassword1 ? 'text' : 'password'" v-model="password_confirmation" class="form-control aa-input" placeholder="Re-enter new password" />
          <span @click="toggleShow1" class="aa-input-toggle">
            <i class="ti" :class="{ 'ti-eye': showPassword1, 'ti-eye-off': !showPassword1 }"></i>
          </span>
        </div>
        <div v-if="errors.password_confirmation" class="text-danger small mt-1">{{ errors.password_confirmation[0] }}</div>
      </div>

      <!-- Submit -->
      <div class="mb-3">
        <button type="submit" class="btn aa-btn-signin w-100">
          Reset Password
          <i class="ti ti-arrow-right ms-1"></i>
        </button>
      </div>

      <div class="text-center">
        <h6 class="fw-normal text-dark mb-0">
          Return to
          <router-link to="/" class="hover-a aa-link">Sign In</router-link>
        </h6>
      </div>
    </div>

    <div class="mt-5 text-center">
      <p class="mb-0 aa-copyright">
        Copyright &copy; 2026 -  Indian Fire Equipment Systems
      </p>
    </div>
  </div>
</form>
</div>
</div>
</div>
</div>
</div>
</div>
</template>

<style scoped>
.aa-form-title {
  font-size: 1.6rem;
  font-weight: 700;
  color: #1e1b4b;
}
.aa-form-subtitle {
  color: #6b7280;
  font-size: 0.9rem;
}
.aa-label {
  font-size: 0.85rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 6px;
}
.aa-input-group {
  position: relative;
  display: flex;
  align-items: center;
}
.aa-input-icon-left {
  position: absolute;
  left: 14px;
  color: #9ca3af;
  font-size: 1.1rem;
  z-index: 2;
  display: flex;
  align-items: center;
}
.aa-input {
  padding-left: 42px !important;
  height: 46px;
  border: 1.5px solid #e5e7eb;
  border-radius: 10px;
  font-size: 0.9rem;
  color: #1f2937;
  background: #f9fafb;
  transition: border-color 0.2s, background-color 0.2s, box-shadow 0.2s;
}
.aa-input::placeholder {
  color: #b0b7c3;
}
.aa-input:focus {
  border-color: #6366f1;
  background: #ffffff;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
}
.aa-input-toggle {
  position: absolute;
  right: 14px;
  color: #9ca3af;
  cursor: pointer;
  z-index: 2;
  display: flex;
  align-items: center;
  font-size: 1.1rem;
  transition: color 0.2s;
}
.aa-input-toggle:hover {
  color: #6366f1;
}
.aa-btn-signin {
  background: linear-gradient(135deg, #e84040 0%, #c0392b 100%);
  border: none;
  color: #ffffff;
  height: 46px;
  border-radius: 10px;
  font-size: 0.95rem;
  font-weight: 600;
  letter-spacing: 0.2px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.15s, box-shadow 0.2s, background 0.2s;
}
.aa-btn-signin:hover {
  background: linear-gradient(135deg, #c0392b 0%, #a93226 100%);
  color: #ffffff;
  box-shadow: 0 4px 14px rgba(232, 64, 64, 0.35);
  transform: translateY(-1px);
}
.aa-link {
  color: #e84040;
  font-weight: 600;
  text-decoration: none;
}
.aa-link:hover {
  color: #c0392b;
}
.aa-copyright {
  font-size: 0.8rem;
  color: #9ca3af;
}
</style>